import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nx-ng-logged-in',
  templateUrl: './logged-in.component.html',
  styleUrls: ['./logged-in.component.scss'],
})
export class LoggedInComponent {

  @Input()
  email?: string | null;

  @Output()
  signOut: EventEmitter<void> = new EventEmitter<void>();

  handleClick() {
    this.signOut.emit();
    return false;
  }
}
